import React, { ReactNode } from 'react';
import clsx from 'clsx';

import ResizableRightSideBar from './ResizableSidebar';

type ResizableLayoutProps = {
  children: ReactNode;
  className?: string;
};

type ContentProps = {
  children: ReactNode;
};

type SidebarProps = {
  children: ReactNode;
  className?: string;
};

const ResizableLayout: React.FC<ResizableLayoutProps> & {
  Content: React.FC<ContentProps>;
  Sidebar: React.FC<SidebarProps>;
} = ({ children, className }: ResizableLayoutProps) => {
  return (
    <div
      className={clsx(
        'mx-auto my-0 w-full p-4 pb-0 sm:px-6 sm:pt-4 xl:pr-0',
        className,
      )}
    >
      <div className="flex flex-col gap-4 lg:flex-row">{children}</div>
    </div>
  );
};

const Content: React.FC<ContentProps> = ({ children }) => {
  return <div className="bg-gray-200 flex-auto p-4">{children}</div>;
};

ResizableLayout.Content = Content;
ResizableLayout.Sidebar = ResizableRightSideBar;

export default ResizableLayout;
